<section class="dream-team" id="dream-team" #sectionEl>

  <!-- Layer 1: pool building image — full bleed background -->
  <img src="/exterior/facade.webp" alt="Acacia building exterior" class="dt-building" aria-hidden="true" />

  <!-- Layer 2: parchment assembled from scattered tiles -->
  <div class="dt-parchment-grid" [class.assembled]="assembled">
    @for (tile of tiles; track tile.col + '-' + tile.row) {
      <div class="dt-tile" [ngStyle]="tileStyle(tile)"></div>
    }
  </div>

  <!-- Layer 3: text content -->
  <div class="dt-content reveal">
    <p class="section-label dt-eyebrow">Behind The Vision</p>
    <h2 class="dt-title">The Dream Team</h2>

    <div class="dt-teams">

      <div class="dt-team-block">
        <p class="dt-role">Developer</p>
        <img src="/logo/a1_black_logo.webp" alt="A One Corporation" class="dt-logo dt-logo--a1" />
      </div>

      <div class="dt-divider" aria-hidden="true"></div>

      <div class="dt-team-block">
        <p class="dt-role">Development Concept &amp; Marketing</p>
        <img src="/logo/karim_logo.webp" alt="Karim Real Estate Elevated" class="dt-logo dt-logo--karim" />
      </div>

    </div>
  </div>

</section>
